import EditTextIcon from '@mui/icons-material/FormatShapes'

const Icon = () => {
  return (
    <EditTextIcon
      htmlColor='rgba(0, 0, 0, 0.54)'
      fontSize='medium'
    />
  )
}

export default Icon
